var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.qrCode.filePath)?_c('div',{staticClass:"qrCode"},[_c('p',[_vm._v("微信扫一扫")]),_c('p',[_vm._v("手机看托盘")]),_c('img',{attrs:{"src":_vm.qrCode.filePath,"alt":"网格九脚注塑托盘"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }